export type TIconName =
  | 'defaultIcon' // 'message-circle-question',
  | 'fileUpload' // 'file-up',
  | 'github'
  | 'npm'
  | 'linkedin'
  | 'privacy' // 'shield-check',
  | 'powerful' // 'biceps-flexed',
  | 'globe'
  | 'tabletSmartphone'
  | 'browser' // panel-top
  | 'twitter'
  | 'appleLogo'
  | 'windowsLogo'
  | 'linuxLogo'
  | 'xmark'

export const IconNames: Record<TIconName, TIconName> = Object.freeze({
  defaultIcon: 'defaultIcon', // 'message-circle-question',
  fileUpload: 'fileUpload', // 'file-up',
  github: 'github',
  npm: 'npm',
  linkedin: 'linkedin',
  privacy: 'privacy', // 'shield-check',
  powerful: 'powerful', // 'biceps-flexed',
  globe: 'globe',
  tabletSmartphone: 'tabletSmartphone',
  browser: 'browser',
  twitter: 'twitter',
  appleLogo: 'appleLogo',
  windowsLogo: 'windowsLogo',
  linuxLogo: 'linuxLogo',
  xmark: 'xmark',
} as const)
